/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Text } from './Text';
import { Title } from './Title';

const BitvavoExchangeLocked = () => {
  const { t } = useTranslation();

  return (
    <>
      <Icon type={'sadFace'} />
      <Title>{t('NOTIFICATION_EXCHANGE_LOCKED__bitvavoTitle')}</Title>
      <Text>{t('NOTIFICATION_EXCHANGE_LOCKED__bitvavoDesc')}</Text>
    </>
  );
};

export { BitvavoExchangeLocked };
